import * as React from 'react';
import HtmlContent from '../_common/html-content';
import CustomLink from '../_common/custom-link';

const gaLabel = 'Product Finder Promo';

function ProductFinderPromo(props: PageSectionData) {
    const { title, content, linkText, linkUrl } = props;
    return (
        <section className="product-finder-promo page-section">
            <div className="page-section__inner">
                <div className="product-finder-promo__content">
                    <HtmlContent html={`${title}${content}`} />
                    <CustomLink text={linkText} gaLabel={gaLabel} url={linkUrl} linkTheme="alternative" hasIcon isUpperCase />
                </div>
            </div>
        </section>
    );
}

export default React.memo(ProductFinderPromo);
